<template>
    <b-modal
      id="verification-modal"
      ref="modal"
      title=""
      hide-footer
      hide-header
    >
      <div class="header">
        <span class="close-icon"
              @click="closeModal">
          <img src="@/assets/svg/close.svg"
               aria-label="close">
        </span>

        <h3>поздравляем <br> с победой!</h3>

        <h5 class="reg-title">
          Для получения приза, пожалуйста, заполните информацию ниже:
        </h5>
      </div>

      <form ref="form"
            class="modal-form"
            @submit.stop.prevent="submit">
        <b-form-group
          id="name-input"
          label-for="name-input"
          :invalid-feedback="invalidName"
        >
          <b-form-input
            id="name-input"
            placeholder="ФИО (полностью)"
            required
            type="text"
            pattern="[A-Za-z]+"
            :class="{ 'is-invalid' : isInvalidName }"
            v-model="$v.item.name.$model"
            :state="validateState($v.item.name)"
          ></b-form-input>

          <span class="input-icon"
                v-if="!item.name">*</span>
        </b-form-group>

        <b-form-group
          label-for="phone-input"
          :invalid-feedback="invalidPhone"
          v-mask="'+7(###)-###-##-##'"
        >
          <b-form-input
            id="phone-input"
            @click="putPlaceholder"
            placeholder="Номер телефона"
            v-model="$v.item.phone.$model"
            maxlength="17"
            ref="phone"
            :class="{ 'is-invalid' : isInvalidPhone, 'is-valid' : !isInvalidPhone }"
            :state="validateState($v.item.phone)"
            required
          ></b-form-input>

          <span class="input-icon"
                v-if="!item.phone">*</span>
       </b-form-group>

        <b-form-group
          id="series-input"
          label-for="series-input"
          :invalid-feedback="invalidSeries"
        >
          <b-form-input
            id="series-input"
            placeholder="Серия и номер паспорта"
            required
            ref="series"
            maxLength="10"
            v-model="$v.item.series.$model"
            :class="{ 'is-invalid' : isInvalidSeries, 'is-valid' : !isInvalidSeries }"
            :state="validateState($v.item.series)"
          ></b-form-input>

          <span class="input-icon"
                v-if="!item.series">*</span>
        </b-form-group>

        <div class="d-flex">
          <b-form-group
            id="who-issued-input"
            label-for="who-issued-input"
            invalid-feedback="Некорректное поле"
          >
            <b-form-input
              id="who-issued-input"
              placeholder="Кем выдан"
              required
              ref="who_issued"
              v-model="$v.item.who_issued.$model"
              :class="{ 'is-invalid' : isInvalidWhoIssued, 'is-valid' : !isInvalidWhoIssued }"
              :state="validateState($v.item.who_issued)"
            ></b-form-input>

            <span class="input-icon"
                  v-if="!item.who_issued">*</span>
          </b-form-group>

          <b-form-group
            id="issue-date-input"
            label-for="issue-date-input"
            invalid-feedback="Некорректное поле"
            v-mask="'##.##.####'"
          >
            <b-form-input
              id="issue-date-input"
              placeholder="Дата выдачи"
              required
              ref="issue_date"
              v-model="$v.item.issue_date.$model"
              :class="{ 'is-invalid' : isInvalidIssuedDate, 'is-valid' : !isInvalidIssuedDate }"
              :state="validateState($v.item.issue_date)"
            ></b-form-input>

            <span class="input-icon"
                  v-if="!item.issue_date">*</span>
          </b-form-group>
        </div>

        <b-form-group
          label-for="inn-input"
          :invalid-feedback="invalidInn"
        >
          <b-form-input
            id="inn-input"
            placeholder="Номер ИНН"
            v-model="$v.item.inn.$model"
            ref="inn"
            maxLength="20"
            :class="{ 'is-invalid' : isInvalidInn, 'is-valid' : !isInvalidInn }"
            :state="validateState($v.item.inn)"
            required
          ></b-form-input>

          <span class="input-icon"
                v-if="!item.inn">*</span>
       </b-form-group>

        <b-form-group
          label-for="address-input"
          :invalid-feedback="invalidAddress"
        >
          <b-form-input
            id="address-input"
            placeholder="Адрес регистрации (прописка)"
            v-model="$v.item.address.$model"
            ref="address"
            :class="{ 'is-invalid' : isInvalidAddress, 'is-valid' : !isInvalidAddress }"
            :state="validateState($v.item.address)"
            required
          ></b-form-input>

          <span class="input-icon"
                v-if="!item.address">*</span>
       </b-form-group>

       <label>
         <input type="file"
                @change="fileChangePassportFirstPage"
                accept="image/jpeg, image/png, image/jpg, image/bmp">

         <span class="fake-button"
               :class="{ active: passportFirstPage.length > 0 }">
          <div class="fake-button-round" v-if="passportFirstPage.length < 1"></div>

          <div class="fake-button-round"
               v-if="passportFirstPage.length > 0" >
            <img src="@/assets/svg/download-icon.svg" />
          </div>

          Загрузить скан паспорта 1-й разворот
        </span>
       </label>

       <div class="">
          <div class="uploaded-img"
               v-for="(image, index) in passportFirstPage"
               :key="index">
            {{ image.name }}

            <div class="delete">
              <img @click.prevent="deleteImageFirst(index)"
                   src="@/assets/svg/close.svg"
                   alt="delete">
            </div>
          </div>
       </div>

       <div class="error"
            v-if="isInvalidFirstPage">
         {{ invalidFirstPage }}
       </div>

       <label>
         <input type="file"
                @change="fileChangePassportSecondPage"
                accept="image/jpeg, image/png, image/jpg, image/bmp">

         <span class="fake-button"
               :class="{ active: passportSecondPage.length > 0 }">
          <div class="fake-button-round" v-if="passportSecondPage.length < 1"></div>

          <div class="fake-button-round"
               v-if="passportSecondPage.length > 0" >
            <img src="@/assets/svg/download-icon.svg" />
          </div>

          Загрузить скан паспорта (прописка)
        </span>
       </label>

       <div class="">
          <div class="uploaded-img"
               v-for="(image, index) in passportSecondPage"
               :key="index">
            {{ image.name }}

            <div class="delete">
              <img @click.prevent="deleteImageSecond(index)"
                   src="@/assets/svg/close.svg"
                   alt="delete">
            </div>
          </div>
       </div>

       <div class="error"
            v-if="isInvalidSecondPage">
         {{ invalidSecondPage }}
       </div>

       <label>
         <input type="file"
                @change="fileChangeDocumentInn"
                accept="image/jpeg, image/png, image/jpg, image/bmp">

         <span class="fake-button"
               :class="{ active: documentInn.length > 0 }">
          <div class="fake-button-round" v-if="documentInn.length < 1"></div>

          <div class="fake-button-round"
               v-if="documentInn.length > 0" >
            <img src="@/assets/svg/download-icon.svg" />
          </div>

          Загрузить скан ИНН
        </span>
       </label>

       <div class="">
          <div class="uploaded-img"
               v-for="(image, index) in documentInn"
               :key="index">
            {{ image.name }}

            <div class="delete">
              <img @click.prevent="deleteImageInn(index)"
                   src="@/assets/svg/close.svg"
                   alt="delete">
            </div>
          </div>
       </div>

       <div class="error"
            v-if="isInvalidFileInn">
         {{ invalidFileInn }}
       </div>
    </form>

    <b-button class="button button-green button-green-bg"
              type="submit"
              :disabled="disabledBtn || submittedBtn"
              @click="submit">Отправить</b-button>
  </b-modal>
</template>

<script>
import axios from 'axios'
import { validationMixin } from "vuelidate"
import { mapGetters, mapMutations } from "vuex"
import { required, requiredIf, minLength, maxLength, or, helpers } from "vuelidate/lib/validators"

const text = helpers.regex('text', /^[?!,.а-яА-ЯёЁ\-\s]+$/)
const email = helpers.regex('email', /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)
const number = helpers.regex('number', /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/)
const token = localStorage.getItem('token-bockarev')

  export default {
    mixins: [validationMixin],

    validations: {
      item: {
        name: {
          required,
          minLength: minLength(2),
          text,
        },
        phone: {
          required,
          minLength: minLength(17),
          maxLength: maxLength(17),
        },
        series: {
          required,
          minLength: minLength(10),
          maxLenght: maxLength(10),
          number,
        },
        inn: {
          required,
          minLength: minLength(10),
          number,
        },
        address: {
          required,
          minLength: minLength(3)
        },
        who_issued: {
          required,
          minLength: minLength(3)
        },
        issue_date: {
          required,
          minLength: minLength(3)
        },
      }
    },

    data() {
      return {
        item: {
          name: '',
          series: '',
          inn: '',
          address: '',
          who_issued: '',
          issue_date: '',
          phone: ''
        },
        documentInn: [],
        passportFirstPage: [],
        passportSecondPage: [],
        isInvalidName: false,
        isInvalidSeries: false,
        isInvalidNumber: false,
        isInvalidInn: false,
        isInvalidPhone: false,
        isInvalidAddress: false,
        isInvalidFirstPage: false,
        isInvalidSecondPage: false,
        isInvalidFileInn: false,
        isInvalidIssuedDate: false,
        isInvalidWhoIssued: false,
        invalidName: 'Некорректное поле',
        invalidPhone: 'Некорректное поле',
        invalidAddress: 'Некорректное поле',
        invalidSeries: 'Некорректное поле',
        invalidNumber: 'Некорректное поле',
        invalidInn: 'Некорректное поле',
        invalidFirstPage: '',
        invalidSecondPage: '',
        invalidFileInn: '',
        submittedBtn: false,
      }
    },

    computed: {
      ...mapGetters({
        token: 'token',
      }),

      disabledBtn(){
        if (this.$v.item.$anyError)
          return true
      },
    },

    mounted(){
      const token = localStorage.getItem('token-bockarev')
    },

    methods: {
      ...mapMutations({
        saveUser: 'saveUser',
        saveToken: 'saveToken'
      }),

      putPlaceholder() {
        if (this.item.phone.length < 2) {
          this.item.phone = "+7";
        }
      },

      resetModal() {
        this.$emit('getThanksText', "Ваши документы отправлены на проверку")

        this.$bvModal.hide('verification-modal')
        this.$bvModal.show('thanks-modal')

        this.$v.$reset()

        this.item.name = '',
        this.item.series = '',
        this.item.inn = '',
        this.submittedBtn = false,
        this.isInvalidName = false,
        this.isInvalidSeries = false,
        this.isInvalidInn = false,
        this.isInvalidAddress = false,
        this.isInvalidNumber = false,
        this.isInvalidFirstPage = false,
        this.isInvalidSecondPage = false,
        this.isInvalidFileInn = false,
        this.invalidName = 'Некорректное поле',
        this.invalidAddress = 'Некорректное поле',
        this.invalidSeries = 'Некорректное поле',
        this.invalidNumber = 'Некорректное поле',
        this.invalidInn = 'Некорректное поле',
        this.invalidFirstPage = '',
        this.invalidSecondPage = '',
        this.invalidFileInn = '',
        this.documentInn = [],
        this.passportFirstPage = [],
        this.passportSecondPage = []
      },

      closeModal(){
        this.$v.$reset()

        this.item.name = '',
        this.item.series = '',
        this.item.inn = '',
        this.submittedBtn = false,
        this.isInvalidName = false,
        this.isInvalidSeries = false,
        this.isInvalidInn = false,
        this.isInvalidAddress = false,
        this.isInvalidNumber = false,
        this.isInvalidFirstPage = false,
        this.isInvalidSecondPage = false,
        this.isInvalidFileInn = false,
        this.invalidName = 'Некорректное поле',
        this.invalidAddress = 'Некорректное поле',
        this.invalidSeries = 'Некорректное поле',
        this.invalidNumber = 'Некорректное поле',
        this.invalidInn = 'Некорректное поле',
        this.invalidFirstPage = '',
        this.invalidSecondPage = '',
        this.invalidFileInn = '',
        this.documentInn = [],
        this.passportFirstPage = [],
        this.passportSecondPage = []

        this.$bvModal.hide('verification-modal')
      },

      // logout(){
      //   axios.post('auth/logout', {
      //   }, {
      //     headers: {
      //       'Accept': "application/json",
      //       'Content-Type': "application/json",
      //       'access-control-allow-origin': "*",
      //       'Authorization': "Bearer " + localStorage.getItem('token-bockarev')
      //     }
      //   }).then((response) => {
      //     this.saveUser(null)
      //     this.saveToken(null)
      //     this.$router.push('/')

      //     localStorage.removeItem('token-bockarev')
      //   }).catch((error) => {
      //       console.log(error)
      //   })
      // },

      fileChangePassportFirstPage(event){
        Array.from(event.target.files).forEach(value => {
          this.passportFirstPage.push(value)
        })

        this.isInvalidFirstPage = false
      },

      fileChangePassportSecondPage(event){
        Array.from(event.target.files).forEach(value => {
          this.passportSecondPage.push(value)
        })

        this.isInvalidSecondPage = false
      },

      fileChangeDocumentInn(event){
        Array.from(event.target.files).forEach(value => {
          this.documentInn.push(value)
        })

        this.isInvalidFileInn = false
      },

      deleteImageFirst(index){
        this.passportFirstPage.splice(index, 1)

        this.isInvalidFirstPage = false
      },

      deleteImageSecond(index){
        this.passportSecondPage.splice(index, 1)

        this.isInvalidSecondPage = false
      },

      deleteImageInn(index){
        this.documentInn.splice(index, 1)

        this.isInvalidFileInn = false
      },

      validateState(item) {
        const { $dirty, $error } = item
        return $dirty ? !$error : null
      },

      submit() {
        this.$v.item.$touch()

        if (this.$v.item.$anyError)
          return false
          this.submittedBtn = true

          const formData = new FormData()
          formData.append('file_passport_one', this.passportFirstPage[0])
          formData.append('file_passport_two', this.passportSecondPage[0])
          formData.append('file_inn', this.documentInn[0])
          formData.append('fio', this.item.name)
          formData.append('passport_serial_number', this.item.series)
          formData.append('inn', this.item.inn)
          formData.append('phone', this.item.phone)
          formData.append('who_issued', this.item.who_issued)
          formData.append('issue_date', this.item.issue_date)
          formData.append('address', this.item.address)

          axios.post('winners/passport', formData, {
            headers: {
              'Accept': "application/json",
              'Content-Type': "multipart/form-data",
              'access-control-allow-origin': "*",
              'Authorization': "Bearer " + localStorage.getItem("token-bockarev"),
            }
          }).then((response) => {
            this.resetModal()
          }).catch((error) => {
            this.submittedBtn = false

            if (error.response.data.message === "Паспортные данные уже добавлены"){
              this.$emit('getErrorText', error.response.data.message)

              this.closeModal()
              this.$bvModal.show('error-modal')
            } if (error.response.data.message === "Время жизни сессии истекло. Пожалуйста, авторизуйтесь"){
              this.$emit('getErrorText', error.response.data.message)

              // this.logout()
              this.closeModal()
              this.$bvModal.show('error-modal')
            } if (error.response.data.message && !error.response.data.errors){
              this.$emit('getErrorText', error.response.data.message)

              this.$bvModal.show('error-modal')
            } if (error.response.data.errors){
              this.invalidFirstPage = 'Заполните поле'
              this.invalidSecondPage = 'Заполните поле'
              this.invalidFileInn = 'Заполните поле'

              if (error.response.data.errors.file_passport_one_page){
                this.isInvalidFirstPage = true
              }

              if (error.response.data.errors.file_passport_two_page){
                this.isInvalidSecondPage = true
              }

              if (error.response.data.errors.file_inn){
                this.isInvalidFileInn = true
              }
            }
        })
      },
    }
  }
</script>

<style scoped lang="scss">
.button {
  margin-top: 40px;
  width: 100%;

  &:hover {
    opacity: 0.8 !important;
  }
}

a {
  color: $red;
}

label {
  width: 100%;
  text-decoration: underline;
  margin-bottom: 10px;
  cursor: pointer;
}

.fake-upload {
  color: $black;
  font-size: 18px;
  font-weight: 400;

  &:hover {
    opacity: 0.9;
  }
}

input[type='file'] {
  position: absolute;
  opacity: 0;
  height: 0;
}

.uploaded-img {
  background-color: $white;
  padding: 10px 15px;
  border-radius: 15px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.delete {
  width: 25px;
  height: 25px;
  background-color: $green;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: .6s all;

  &:hover {
    opacity: 0.8;
  }

  img {
    max-width: 10px;
    max-height: 10px;
  }
}

.error {
  color: $red;
  font-size: 12px;
  margin-top: -20px;
}

.reg-title {
  color: white;
  margin-top: 10px;
  margin-bottom: 28px;
  font-size: 18px;
  font-weight: 400;
  line-height: 116%;
}

.fake-button-round {
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 50%;
  margin-right: 4px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fake-button {
  color: white;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  &.active {
    color: #FBD6A1;
    text-decoration: underline;
  }
}
</style>
